export const SET_USERS = "SET_USERS";
export const SET_CREATED_USER = "SET_CREATED_USER";
export const SET_UPDATED_USER = "SET_UPDATED_USER";
export const REMOVE_DELETED_USER = "REMOVE_DELETED_USER";
export const SET_USER_ERROR = "SET_USER_ERROR";
export const SET_USERS_LOADING = "SET_USERS_LOADING";
export const SET_USERS_FETCHING = "SET_USERS_FETCHING";
export const SET_USERS_ROLES = "SET_USERS_ROLES";
export const DELETE_USERS_FETCHING = "DELETE_USERS_FETCHING";
